import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { injectIntl, defineMessages } from 'react-intl';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import Infinite from 'react-infinite';
import ReactHtmlParser from 'react-html-parser';

import { Segment, Grid, Icon, Form, Image, Input, Dropdown, Popup } from 'semantic-ui-react';
import { Checkbox, FormControlLabel, Tooltip, IconButton } from 'material-ui';

import { Button, Loading, TargetList } from 'components';
import { CtTargetHeader } from 'containers';

import styles from './Target.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class Target extends Component {
  constructor(props) {
    super(props);
  }

  // 훈련 결과 입력
  onSearchChange = e => {
    const { takeSearchValue } = this.props;
    takeSearchValue(e.target.value);
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      selectTarget,
      selectedTag,
      tagDataByTagNo,
      targetOrdering,
      targetDataByTargetNo,
      targetParam,
      isLoading,
      page,
      totalPages,
      totalTarget,
      targetScrollData,
      onGetTarget,
      onSortTarget,
      onSortOrdering,
      onSearchTarget,
      onRefScroll,
      getFilterParam,
      filterLength,
      scrollRef
    } = this.props;
    // 선택 이벤트
    const { handleCheckAllTarget, handleCheckTotalTarget, handleCheckTarget, handleSelectTarget } = this.props;
    // 필터
    const {
      searchText,
      targetFilter,
      onFilterExamInfo,
      onFilterDivision,
      onFilterPosition,
      onFilterCancel,
      searchTextRef,
      executeFilter,
      filterUpdate,
      cancleCheck,
      filterClose,
      tempFilter,
      popupOpen,
      handlePopup
    } = this.props;

    // 최근 훈련 필터
    const examInfoTypeArray = [
      { noExam: defineMessages(formatMessage({ id: 'Target_22', defaultMessage: '결과 없음' })) },
      { send: defineMessages(formatMessage({ id: 'Target_23', defaultMessage: '양호' })) },
      { read: defineMessages(formatMessage({ id: 'Target_24', defaultMessage: '메일 열람' })) },
      { download: defineMessages(formatMessage({ id: 'Target_29', defaultMessage: '파일 다운/피싱 접속' })) },
      {
        infection: ReactHtmlParser(
          defineMessages(formatMessage({ id: 'Target_30', defaultMessage: 'PC 감염/정보 유출' }))
        )
      },
      { cure: defineMessages(formatMessage({ id: 'Target_28', defaultMessage: '치료' })) }
    ];

    const examInfoFilterOptions = (
      <Dropdown.Menu>
        <Dropdown.Header content={defineMessages(formatMessage({ id: 'Target_27', defaultMessage: '최근 훈련' }))} />
        {examInfoTypeArray.map((data, index) => {
          return (
            <Dropdown.Item
              key={index}
              value={Object.keys(data)[0]}
              onClick={(e, props) => {
                e.stopPropagation();
                onFilterExamInfo(props);
              }}>
              <div className={cx('check-box')}>
                <Image
                  className={
                    !!tempFilter['examInfoArray'] &&
                      tempFilter['examInfoArray'].findIndex(f => f === Object.keys(data)[0]) !== -1
                      ? 'checkmark box'
                      : 'outline box'
                  }
                  src="/img/target/ico-check.png"
                />
              </div>
              <div className={cx('box-text')}>{data[Object.keys(data)[0]]}</div>
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    );
    const eFilterText = isFilteredE
      ? defineMessages(formatMessage({ id: 'Target_27', defaultMessage: '최근 훈련' })) +
      ': ' +
      eFilterTextInner.join(', ')
      : defineMessages(formatMessage({ id: 'Target_27', defaultMessage: '최근 훈련' }));

    // 직급 필터
    const positionFilterOptions = (
      <Dropdown.Menu>
        <Dropdown.Header content={defineMessages(formatMessage({ id: 'Target_7', defaultMessage: '직급' }))} />
        {!!targetFilter.get('targetPosition') &&
          targetFilter.get('targetPosition').map((filter, index) => {
            return (
              <Dropdown.Item
                key={index}
                value={filter}
                onClick={(e, props) => {
                  e.stopPropagation();
                  onFilterPosition(props);
                }}>
                <div className={cx('check-box')}>
                  <Image
                    className={
                      !!tempFilter['targetPositionArray'] &&
                        tempFilter['targetPositionArray'].findIndex(filterItem => filterItem === filter) !== -1
                        ? 'checkmark box'
                        : 'square outline'
                    }
                    src="/img/target/ico-check.png"
                  />
                </div>
                <div className={cx('box-text')}>{filter}</div>
              </Dropdown.Item>
            );
          })}
      </Dropdown.Menu>
    );

    //소속 필터
    const divisionFilterOptions = (
      <Dropdown.Menu>
        <Dropdown.Header content={defineMessages(formatMessage({ id: 'Target_6', defaultMessage: '소속' }))} />
        {!!targetFilter.get('targetDivision') &&
          targetFilter.get('targetDivision').map((filter, index) => {
            return (
              <Dropdown.Item
                key={index}
                value={filter}
                onClick={(e, props) => {
                  e.stopPropagation();
                  onFilterDivision(props);
                }}>
                <div className={cx('check-box')}>
                  <Image
                    className={
                      !!tempFilter['targetDivisionArray'] &&
                        tempFilter['targetDivisionArray'].findIndex(filterItem => filterItem === filter) !== -1
                        ? 'checkmark box'
                        : 'square outline'
                    }
                    src="/img/target/ico-check.png"
                  />
                </div>
                <div className={cx('box-text')}>{filter}</div>
              </Dropdown.Item>
            );
          })}
      </Dropdown.Menu>
    );

    let examInfoArray =
      targetParam.getIn(['filter', 'examInfoArray']) && targetParam.getIn(['filter', 'examInfoArray']).toJS();

    let targetDivisionArray =
      targetParam.getIn(['filter', 'targetDivisionArray']) &&
      targetParam.getIn(['filter', 'targetDivisionArray']).toJS();

    let targetPositionArray =
      targetParam.getIn(['filter', 'targetPositionArray']) &&
      targetParam.getIn(['filter', 'targetPositionArray']).toJS();

    if (examInfoArray === undefined) {
      examInfoArray = [];
    }
    if (targetDivisionArray === undefined) {
      targetDivisionArray = [];
    }
    if (targetPositionArray === undefined) {
      targetPositionArray = [];
    }

    const totalArrayLength = examInfoArray.length + targetDivisionArray.length + targetPositionArray.length;
    const filterTargetArray = [];
    const filterDivisionArray = [];
    const filterPositionArray = [];

    if (examInfoArray.length > 0) {
      examInfoArray.map((targetStatus, index) => {
        if (targetStatus === 'noExam') {
          filterTargetArray.push(defineMessages(formatMessage({ id: 'Target_22', defaultMessage: '결과 없음' })));
        } else if (targetStatus === 'send') {
          filterTargetArray.push(defineMessages(formatMessage({ id: 'Target_23', defaultMessage: '양호' })));
        } else if (targetStatus === 'read') {
          filterTargetArray.push(defineMessages(formatMessage({ id: 'Target_24', defaultMessage: '메일 열람' })));
        } else if (targetStatus === 'download') {
          filterTargetArray.push(
            defineMessages(formatMessage({ id: 'Target_29', defaultMessage: '파일 다운/피싱 접속' }))
          );
        } else if (targetStatus === 'infection') {
          filterTargetArray.push(
            ReactHtmlParser(defineMessages(formatMessage({ id: 'Target_30', defaultMessage: 'PC 감염/정보 유출' })))
          );
        } else if (targetStatus === 'cure') {
          filterTargetArray.push(defineMessages(formatMessage({ id: 'Target_28', defaultMessage: '치료' })));
        }
      });
    }
    if (targetDivisionArray.length > 0) {
      targetDivisionArray.map((division, index) => {
        filterDivisionArray.push(division);
      });
    }
    if (targetPositionArray.length > 0) {
      targetPositionArray.map((position, index) => {
        filterPositionArray.push(position);
      });
    }
    const tooltipInfo = (
      <div className={cx('tooltip-wrapper')}>
        <div className={cx('arrow')} />

        {filterTargetArray.length > 0 && (
          <div className={cx('tooltip-row')}>
            <div className={cx('tooltip-title')}>
              <span className={cx('title-dot')} />
              {defineMessages(formatMessage({ id: 'Target_27', defaultMessage: '최근 훈련' }))}
            </div>
            <span className={cx('tooltip-context')}>{filterTargetArray.join(', ')}</span>
          </div>
        )}
        {filterDivisionArray.length > 0 && (
          <div className={cx('tooltip-row')}>
            <div className={cx('tooltip-title')}>
              <span className={cx('title-dot')} />
              {defineMessages(formatMessage({ id: 'Target_6', defaultMessage: '소속' }))}
            </div>
            <span className={cx('tooltip-context')}>{filterDivisionArray.join(', ')}</span>
          </div>
        )}
        {filterPositionArray.length > 0 && (
          <div className={cx('tooltip-row')}>
            <div className={cx('tooltip-title')}>
              <span className={cx('title-dot')} />
              {defineMessages(formatMessage({ id: 'Target_7', defaultMessage: '직급' }))}
            </div>
            <span className={cx('tooltip-context')}>{filterPositionArray.join(', ')}</span>
          </div>
        )}
      </div>
    );

    const isFilteredE =
      !!targetParam.getIn(['filter', 'examInfoArray']) && targetParam.getIn(['filter', 'examInfoArray']).size > 0;
    const isFilteredD =
      !!targetParam.getIn(['filter', 'targetDivisionArray']) &&
      targetParam.getIn(['filter', 'targetDivisionArray']).size > 0;
    const isFilteredP =
      !!targetParam.getIn(['filter', 'targetPositionArray']) &&
        targetParam.getIn(['filter', 'targetPositionArray']).size > 0
        ? true
        : false;
    const isFiltered = isFilteredE || isFilteredD || isFilteredP || !!targetParam.getIn(['filter', 'searchAll']);
    const eFilterTextInner = [];
    const dFilterTextInner = [];
    const pFilterTextInner = [];
    const dFilterText = isFilteredD
      ? defineMessages(formatMessage({ id: 'Target_1', defaultMessage: '소속 필터' })) +
      ': ' +
      dFilterTextInner.join(', ')
      : defineMessages(formatMessage({ id: 'Target_1', defaultMessage: '소속 필터' }));

    const pFilterText = isFilteredP
      ? defineMessages(formatMessage({ id: 'Target_2', defaultMessage: '직급 필터' })) +
      ': ' +
      pFilterTextInner.join(', ')
      : defineMessages(formatMessage({ id: 'Target_2', defaultMessage: '직급 필터' }));

    const sortOptions = [
      {
        text: defineMessages(formatMessage({ id: 'Target_3', defaultMessage: '등록순' })),
        value: 'targetNo'
      },
      {
        text: defineMessages(formatMessage({ id: 'Target_4', defaultMessage: '이름' })),
        value: 'targetName'
      },
      {
        text: defineMessages(formatMessage({ id: 'Target_5', defaultMessage: '이메일' })),
        value: 'targetEmail'
      },
      {
        text: defineMessages(formatMessage({ id: 'Target_6', defaultMessage: '소속' })),
        value: 'targetDivision'
      },
      {
        text: defineMessages(formatMessage({ id: 'Target_7', defaultMessage: '직급' })),
        value: 'targetPosition'
      }
    ];

    let selectedTagText = '';
    if (selectedTag.get(0) === 'all-tag') {
      selectedTagText = defineMessages(formatMessage({ id: 'Target_17', defaultMessage: '모든 태그' }));
    } else if (selectedTag.get(0) === 'no-tag') {
      selectedTagText = defineMessages(formatMessage({ id: 'Tag_9', defaultMessage: '태그가 없는 대상자' }));
    } else if (selectedTag.size > 0) {
      selectedTagText = tagDataByTagNo.getIn([String(selectedTag.get(0)), 'tagName']);

      if (selectedTag.size > 1) {
        selectedTagText +=
          ' ' +
          defineMessages(formatMessage({ id: 'TargetHeader_3', defaultMessage: '외' })) +
          (selectedTag.size - 1) +
          defineMessages(formatMessage({ id: 'TargetHeader_4', defaultMessage: '개 태그' }));
      }
    }

    const isAllChecked =
      selectTarget.get('isAllCheckTarget') === 1 || selectTarget.get('isAllCheckTarget') === 2 ? true : false;

    const AllCheckbox = (
      <div className={cx('checkbox-area')}>
        <FormControlLabel
          className={cx('all-checkbox')}
          control={
            <Checkbox
              className={cx('targetAll-checkBox')}
              onChange={handleCheckAllTarget}
              checked={isAllChecked}
              indeterminate={selectTarget.get('isAllCheckTarget') === 3 ? true : false}
              checkedIcon={isAllChecked ? <img src="/img/exam/list_check_on.png" /> : null}
              indeterminateIcon={
                selectTarget.get('isAllCheckTarget') === 3 ? <img src="/img/exam/list_check_each.png" /> : null
              }
            />
          }
          label={
            <span className={cx('check-text')}>
              {isAllChecked
                ? defineMessages(formatMessage({ id: 'Target_8', defaultMessage: '전체해제' }))
                : defineMessages(formatMessage({ id: 'Target_18', defaultMessage: '현재 리스트' }))}
            </span>
          }
        />
        {totalTarget > 100 &&
          isAllChecked && (
            <Tooltip
              title={
                defineMessages(formatMessage({ id: 'Target_36', defaultMessage: ' ' })) +
                selectedTagText +
                defineMessages(formatMessage({ id: 'Target_19', defaultMessage: '의 모든 대상자를 선택합니다.' }))
              }
              placement="top">
              <Button
                className={cx('bt-checkTotal', { selected: selectTarget.get('isAllCheckTarget') === 2 })}
                size="mini"
                buttonColor="#dddddd"
                fontColor="#757575"
                onClick={handleCheckTotalTarget}>
                <div className={cx('all-icon small')}>All</div>
                <span className={cx('check-text')}>
                  {defineMessages(formatMessage({ id: 'Target_21', defaultMessage: '모든 대상자' }))}
                </span>
              </Button>
            </Tooltip>
          )}
      </div>
    );

    return (
      <div className={cx('target-wrapper')}>
        <CtTargetHeader
          onGetTarget={onGetTarget}
          scrollRef={scrollRef}
        />
        <div className={cx('target-subHeader')}>
          <Segment vertical>
            <Grid columns="equal" stackable>
              <Grid.Row textAlign="left">
                <Grid.Column width={5}>{AllCheckbox}</Grid.Column>
                <Grid.Column width={11} className={cx('target-filter-area')} textAlign="right">
                  <Tooltip
                    title={
                      targetParam.get('sort')[0]['order'] === 'DESC'
                        ? defineMessages(formatMessage({ id: 'Target_10', defaultMessage: '오름차순으로 변경' }))
                        : defineMessages(formatMessage({ id: 'Target_11', defaultMessage: '내림차순으로 변경' }))
                    }
                    placement="top">
                    <Button
                      className={cx('bt-targetSort')}
                      size="mini"
                      buttonColor="#dddddd"
                      fontColor="#757575"
                      onClick={onSortOrdering}
                      icon={
                        targetParam.get('sort')[0]['order'] === 'DESC' ? (
                          <img src="/img/exam/list_descending.png" />
                        ) : (
                            <img src="/img/exam/list_ascending.png" />
                          )
                      }
                    />
                  </Tooltip>
                  <Tooltip
                    title={defineMessages(formatMessage({ id: 'Target_12', defaultMessage: '정렬 방법 선택' }))}
                    placement="top">
                    <div className={cx('dropdown-sort')}>
                      <div className={cx('dropdown-arrow-area')}>
                        <Image className={cx('dropdown-image')} src={'/img/target/list_select.png'} />
                      </div>
                      <Dropdown
                        className={cx('dropdown-targetSort')}
                        placeholder={defineMessages(formatMessage({ id: 'Target_3', defaultMessage: '등록순' }))}
                        floating
                        button
                        options={sortOptions}
                        onChange={onSortTarget}
                      />
                    </div>
                  </Tooltip>
                  <Tooltip
                    classes={{
                      tooltip: 'tooltip',
                      tooltipOpen: totalArrayLength > 0 ? '' : 'close'
                    }}
                    title={tooltipInfo}
                    placement="bottom">
                    <div
                      className={cx(
                        'target-dropdown-area border-color',
                        totalArrayLength > 0 ? 'target-dropdown-area-border' : ''
                      )}>
                      <div className={cx('dropdown-arrow-area')}>
                        {totalArrayLength > 0 ? (
                          <div className={cx('number-box')}>{totalArrayLength}</div>
                        ) : (
                            <Image className={cx('dropdown-image')} src={'/img/target/list_select.png'} />
                          )}
                      </div>
                      <Popup
                        className={cx('filter-popup')}
                        trigger={
                          <div className={cx('default-text', totalArrayLength > 0 ? 'filter-length' : '')}>
                            {defineMessages(formatMessage({ id: 'Target_31', defaultMessage: '필터' }))}
                          </div>
                        }
                        open={popupOpen}
                        onOpen={() => handlePopup(true)}
                        onClose={() => { filterClose(), handlePopup(false) }}
                        on="click"
                        flowing
                        position="bottom center">
                        <Grid centered divided columns={3}>
                          <Grid.Column textAlign="left">{examInfoFilterOptions}</Grid.Column>
                          <Grid.Column textAlign="left">{divisionFilterOptions}</Grid.Column>
                          <Grid.Column textAlign="left">{positionFilterOptions}</Grid.Column>
                        </Grid>
                        <Grid className={cx('bottom-options')}>
                          <Grid.Column>
                            <div className={cx('all-check-off')} onClick={onFilterCancel}>
                              {defineMessages(formatMessage({ id: 'Target_32', defaultMessage: '모든 필터 해제' }))}
                            </div>
                            <div className={cx('inline-block')}>
                              <Button className={cx('button-border', 'button')} onClick={() => { cancleCheck(), handlePopup(false) }}>
                                {defineMessages(formatMessage({ id: 'TargetDetail_7', defaultMessage: '취 소' }))}
                              </Button>
                              <Button
                                className={cx('button-brand', 'button')}
                                // loading={editOnProgress}
                                // disabled={disableSave && (editInvalid || editOnProgress)}
                                onClick={() => { executeFilter(), handlePopup(false) }}>
                                {defineMessages(formatMessage({ id: 'TargetDetail_37', defaultMessage: '확 인' }))}
                              </Button>
                            </div>
                          </Grid.Column>
                        </Grid>
                      </Popup>
                      {/* <Tooltip title={eFilterText} placement="top">
                      <div className={cx('dropdown-filter')}>
                        <div className={cx('dropdown-arrow-area')}>
                          <Image className={cx('dropdown-image')} src={'/img/target/list_select.png'} />
                        </div>
                        <Dropdown
                          className={cx('examInfoFilter', 'icon', {
                            isFiltered: isFiltered
                          })}
                          text={defineMessages(formatMessage({ id: 'Target_27', defaultMessage: '최근 훈련' }))}
                          icon={null}
                          floating
                          button
                          scrolling>
                          {examInfoFilterOptions}
                        </Dropdown>
                      </div>
                    </Tooltip> */}
                      {/* <Tooltip title={dFilterText} placement="top">
                      <div className={cx('dropdown-filter')}>
                        <div className={cx('dropdown-arrow-area')}>
                          <Image className={cx('dropdown-image')} src={'/img/target/list_select.png'} />
                        </div>
                        <Dropdown
                          className={cx('divisionFilter', {
                            isFiltered: isFiltered
                          })}
                          text={defineMessages(formatMessage({ id: 'Target_6', defaultMessage: '소속' }))}
                          icon={null}
                          floating
                          button
                          scrolling
                          disabled={!!targetFilter.get('targetDivision') ? false : true}>
                          {divisionFilterOptions}
                        </Dropdown>
                      </div>
                    </Tooltip> */}
                      {/* <Tooltip title={pFilterText} placement="top">
                      <div className={cx('dropdown-filter')}>
                        <div className={cx('dropdown-arrow-area no-border')}>
                          <Image className={cx('dropdown-image')} src={'/img/target/list_select.png'} />
                        </div>
                        <Dropdown
                          className={cx('positionFilter', {
                            isFiltered: isFiltered
                          })}
                          text={defineMessages(formatMessage({ id: 'Target_7', defaultMessage: '직급' }))}
                          icon={null}
                          floating
                          button
                          scrolling
                          disabled={!!targetFilter.get('targetPosition') ? false : true}>
                          {positionFilterOptions}
                        </Dropdown>
                      </div>
                    </Tooltip> */}
                    </div>
                  </Tooltip>
                  <div className={cx('search-input-area')}>
                    <Input
                      size="mini"
                      placeholder={defineMessages(formatMessage({ id: 'Target_14', defaultMessage: '검색' }))}
                      onChange={this.onSearchChange}
                      onKeyPress={onSearchTarget}
                      // value={searchText}
                      ref={searchTextRef}
                    />
                    <Button
                      id="bt-searchTarget"
                      fontColor="#757575"
                      size="mini"
                      icon={<img src="/img/exam/list_search.png" />}
                      onClick={onSearchTarget}
                    />
                  </div>
                  <Tooltip
                    title={defineMessages(formatMessage({ id: 'Target_13', defaultMessage: '필터 해제' }))}
                    placement="top">
                    {/* <Button className={cx('bt-filterCancel')} size="mini" onClick={onFilterCancel} icon="cancel" /> */}
                    <IconButton className={cx('bt-filterCancel')} onClick={onFilterCancel}>
                      <Image src={'/img/table/btn_filter' + (isFiltered ? '_active' : '') + '.png'} />
                    </IconButton>
                  </Tooltip>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>
        </div>
        <TargetList
          targetOrdering={targetOrdering}
          tagDataByTagNo={tagDataByTagNo}
          targetDataByTargetNo={targetDataByTargetNo}
          selectTarget={selectTarget}
          handleCheckTarget={handleCheckTarget}
          handleSelectTarget={handleSelectTarget}
          targetScrollData={targetScrollData}
          onRefScroll={onRefScroll}
          page={page}
          totalPages={totalPages}
          onGetTarget={onGetTarget}
          isLoading={isLoading}
          filterUpdate={filterUpdate}
        />
      </div>
    );
  }
}

Target.propTypes = {
  handleCheckAllTarget: PropTypes.func,
  handleCheckTarget: PropTypes.func,
  handleSelectTarget: PropTypes.func
};

export default injectIntl(Target);



// WEBPACK FOOTER //
// ./src/script/components/target/Target.js